"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  const validMenuItems = menuItems?.filter(item => item.href) || [];
  if (validMenuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {validMenuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href!} className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function InformationAndRights() {
  const popularCities = [{
    name: "תל אביב",
    path: "/NursingCaregiverInTelAvivWithinFiveHoursPage"
  }, {
    name: "רמת גן",
    path: "/NursingCareInRamatGanWithinHoursPage"
  }, {
    name: "חיפה",
    path: "/NursingCareProviderInHaifaWithinHoursPage"
  }, {
    name: "ירושלים",
    path: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
  }, {
    name: "באר שבע",
    path: "/NursingCareProviderInBeershevaWithinHoursPage"
  }];
  return <section data-section-id="204518" id="מידע-משפטי-וניווט" className="dark bg-background text-foreground py-16 px-6 md:px-12 border-t border-border/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-12">
          
          <div className="md:col-span-5 flex flex-col items-start gap-6">
            <Link to="/">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm max-w-sm leading-relaxed text-right md:text-start font-default">
              מטפל סיעודי תוך שעות, לא ימים. אנו מספקים מטפלים סיעודיים ישראלים תוך עד 5 שעות בלבד, בפריסה ארצית מלאה, לבית ולבית החולים.
            </p>
          </div>

          <div className="md:col-span-4 flex flex-col items-start gap-6">
            <h3 className="font-default font-semibold text-lg tracking-wide text-primary-foreground">ניווט מהיר</h3>
            <MenuProvider menu_id="20">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="md:col-span-3 flex flex-col items-start md:items-end gap-6">
            <h3 className="font-default font-semibold text-lg tracking-wide text-primary-foreground">צרו קשר</h3>
            <div className="flex gap-4">
              <Link to="https://www.linkedin.com/" newTab className="text-muted-foreground hover:text-secondary transition-colors duration-300" aria-label="LinkedIn">
                <Linkedin className="size-6" />
              </Link>
            </div>
          </div>

        </div>

        <div className="mb-12">
          <h3 className="font-default font-semibold text-lg tracking-wide text-primary-foreground mb-6">ערים פופולריות</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-6">
            {popularCities.map((city, i) => <Link key={i} data-index={i} to={city.path} className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                מטפל סיעודי ב{city.name}
              </Link>)}
          </div>
          <Link to="/CitySpecificSEOPagesForNursingCareProviderPage" className="text-secondary hover:underline text-sm font-default font-medium">
            כל הערים
          </Link>
        </div>

        <Separator className="bg-border/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/60 font-default">
          <p>© 2024 Siudy – סיעוד מיידי. כל הזכויות שמורות.</p>
        </div>
      </div>

      <div className="fixed bottom-4 right-4 z-50">
        <Button asChild className="rounded-lg bg-[#12b5d4] hover:bg-[#12b5d4]/90 text-white shadow-xl shadow-[#12b5d4]/20 h-14 px-8 text-lg font-bold transition-all hover:scale-105 active:scale-95">
          <Link to="#">התקשר עכשיו</Link>
        </Button>
      </div>
    </section>;
}